import { useQuery } from '@pinia/colada';

import agentChatService from '../services/agent-chat.service';

export const agentChatThreadQueryKey = 'agent-chat-thread';

export function getAgentChatThreadQueryKey() {
  return ['agent-chat', agentChatThreadQueryKey];
}

/**
 * Newest page of the owner's agent thread. staleTime 0 so every panel open refetches: socket
 * pushes are best-effort (an emit only reaches sockets connected to the emitting API pod), so
 * mount-time freshness is the delivery guarantee and the socket is just the fast path.
 */
export function useAgentChatThreadQuery() {
  return useQuery({
    key: getAgentChatThreadQueryKey(),
    staleTime: 0,
    query: () => agentChatService.getThread(),
  });
}
